 <template>
     <div class="review-stars">
             <span class="glyphicon glyphicon-star" v-for="x in this.score"></span>
             <span class="glyphicon glyphicon-star-empty" v-for="y in (this.totalScore - this.score)"></span>
     </div>
 </template>

<script>
export default {
    props: {
        score: {
            type: Number,
            required: true
        },
        totalScore: {
            type: Number,
            required: true
        }
    },
    name: "review-stars"
};
</script>
